import React from 'react';
import { Button } from '../ui';

/** @deprecated Use `<Button variant="outline" />` from `../ui`. */
const TextCancelButton = React.forwardRef(function TextCancelButton(props, ref) {
  return <Button ref={ref} variant="outline" {...props} />;
});

export default TextCancelButton;
